import React, {useEffect, useRef, useState} from 'react';
import './style.scss'
import UsersList from "../UsersList/UsersList";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import AddIcon from '@material-ui/icons/AddRounded';
import SearchIcon from '@material-ui/icons/SearchRounded';
import IconButton from "@material-ui/core/IconButton";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import GroupIcon from "@material-ui/icons/Group";

export default function Users(props) {
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [searchText, setSearchText] = useState();
    const [profileTab, setProfileTab] = useState("all");
    const [profiles, setProfiles] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState();
    const searchInputRef = useRef();

    function onAddUserClicked() {
        setSelectedUserId(null);

        if (props.onAddUserClicked)
            props.onAddUserClicked()
    }

    function onSearchUsersClicked() {
        const isSearchOpenNewValue = !isSearchOpen;

        setIsSearchOpen(isSearchOpenNewValue);

        if (isSearchOpenNewValue)
            searchInputRef.current.focus();
        else
            onSearchTextChanged("");
    }

    function onSearchUsersClickedAway() {
        if (isSearchOpen) {
            setIsSearchOpen(false);

            onSearchTextChanged("");
        }
    }

    function onProfileTabChange(newProfileName) {
        setProfileTab(newProfileName);
        setUsers(filterUsersByProfileAndSearch(props.users, newProfileName, searchText));
    }

    function onSearchTextChanged(newSearchText) {
        setSearchText(newSearchText);
        setUsers(filterUsersByProfileAndSearch(props.users, profileTab, newSearchText));
    }

    function filterUsersByProfileAndSearch(users, profileName, searchText) {
        const usersByProfile = profileName === "all" ? users : users.filter(user => profileName in user.profiles);

        const usersBySearch = !searchText ? usersByProfile : usersByProfile.filter(user => isTextIncludesTokenizedText(user.name, searchText));

        return usersBySearch;
    }

    function isTextIncludesTokenizedText(mainText, includedText) {
        const tokenizedIncludedText = includedText.split(" ");

        return tokenizedIncludedText.every(includedToken => mainText.includes(includedToken));
    }

    function onUserSelect(userId) {
        const newSelectedUserId = userId === selectedUserId ? undefined : userId;

        setSelectedUserId(newSelectedUserId);

        if (props.onUserSelect)
            props.onUserSelect(newSelectedUserId)
    }

    useEffect(() => {
        const usersProfileNames = [...new Set(props.users.flatMap(user => Object.keys(user.profiles)))];

        const userProfiles = usersProfileNames.map(userProfileName => props.profiles.find(profile => profile.name === userProfileName));

        userProfiles.sort((a, b) => a.level - b.level);

        setProfiles(userProfiles);

        setUsers(filterUsersByProfileAndSearch(props.users, profileTab, searchText));
    }, [props.users, props.profiles]);

    const tabStyles = {
        minWidth: "auto", // a number of your choice
    };

    return (
        <div className="users">
            <div className="users-title-container">
                <div className="users-title-text">
                    <GroupIcon style={{"fontSize": "32px"}}/>
                    &nbsp;
                    עובדים
                </div>
                <div className="users-actions">
                    <ClickAwayListener onClickAway={onSearchUsersClickedAway}>
                        <div className={"search-users-container" + (isSearchOpen ? " search-users-open" : "")}>
                            <div className="search-input-container">
                                <input value={searchText} onChange={e => onSearchTextChanged(e.target.value)}
                                       className="search-input" type="text" placeholder="חפש שם" ref={searchInputRef}/>
                            </div>
                            <Tooltip arrow title="חפש משתמשים" aria-label="Search">
                                <IconButton className="search-users-button" aria-label="Add"
                                            onClick={onSearchUsersClicked}>
                                    <SearchIcon/>
                                </IconButton>
                            </Tooltip>
                        </div>
                    </ClickAwayListener>
                    <div className="add-user-container">
                        <Tooltip arrow title="הוסף משתמש" aria-label="Add">
                            <IconButton className="add-user-button" aria-label="Add"
                                        onClick={onAddUserClicked}>
                                <AddIcon/>
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
            </div>
            <div className="profile-tabs">
                <Tabs
                    value={profileTab}
                    onChange={(event, newValue) => onProfileTabChange(newValue)}
                    indicatorColor="primary"
                    textColor="primary"
                    scrollButtons="auto"
                    variant="scrollable"
                >
                    <Tab label="כל העובדים" value="all"/>
                    {
                        profiles.map(profile => (
                            <Tab key={profile.name} label={profile.displayNameMany} value={profile.name}/>
                        ))
                    }
                </Tabs>
            </div>
            <div className="users-list-container">
                <UsersList users={users}
                           selectedUserId={selectedUserId}
                           onUserSelect={onUserSelect}/>
            </div>
        </div>
    );
}